import { ENUM__component_type } from '@/enums/ENUM__component_type';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_hint_shortcut } from '@/hooks/hints_shortcut/use_hint_shortcut';
import { use_slice_generation, use_slice_ui, use_slice_user } from '@/hooks/store/use_slices';
import { use_generation_current_price } from '@/hooks/use_generation_current_price';
import { REMOTE__generation_start_with_new_seeds } from '@/state/generation/status/REMOTE__generation_start_with_new_seeds';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { ENUM__generation_status } from '@shared/dto/generation/_enums/ENUM__generation_status';
import { DTO_REQUEST__generation_start } from '@shared/dto/generation/_requests/DTO_REQUEST__generation_start';
import { EShortcutType } from '@shared/dto/hint_shortcuts/e_shortcut_type';
import { useMemo } from 'react';
import { HOOK_GENERATION__notifier } from './HOOK_GENERATION__notifier';

export function HOOK_GENERATION__start_with_new_seeds() {
  const dispatch = use_dispatch();

  const { notifier } = HOOK_GENERATION__notifier(ENUM__component_type.PAGE_GENERATION_BUTTON_GENERATION_START_WITH_NEW_SEEDS);

  const { user_settings } = use_slice_user(['user_settings']);
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);
  const { generation_current, generation_ids_with_locked_status } = use_slice_generation(['generation_current', 'generation_ids_with_locked_status']);

  const { on_user_uses_shortcut, on_user_uses_component } = use_hint_shortcut(EShortcutType.GENERATION_START);

  const { generation_current_price } = use_generation_current_price(false);

  const can_start_generation_with_new_seeds = useMemo(
    () => get_can_generate_new_seeds_and_start_generation(),
    [generation_current.status, generation_ids_with_locked_status, generation_current_price, g_general__ui_disabled],
  );

  /*
   * METHODS
   */

  async function generation_start_with_new_seeds(is_used_shortcut: boolean) {
    if (!can_start_generation_with_new_seeds) return;

    generation_current.assert_not_statuses([ENUM__generation_status.IN_PROGRESS]);

    let request = new DTO_REQUEST__generation_start();
    request.generation_id = generation_current._id;
    request.ml_asset_reservation_id = ENUM__string_id_empty.OBJECT_ID;

    await dispatch(REMOTE__generation_start_with_new_seeds(request));

    await notifier.send_action();

    is_used_shortcut ? on_user_uses_shortcut() : on_user_uses_component();
  }

  function get_can_generate_new_seeds_and_start_generation() {
    if (isNaN(generation_current_price)) return false; //determining price
    if (generation_current.is_in_progress) return false;
    if (generation_ids_with_locked_status.has(generation_current._id)) return false;
    if (g_general__ui_disabled) return false;
    if (generation_current.tool.graph.field_get__noise_seed().is_stub()) return false;

    return true;
  }

  return { generation_start_with_new_seeds, can_start_generation_with_new_seeds };
}
